module.exports = __webpack_public_path__ + "img/1.098f4933.png";